/* 陸遜傳・第 3 章：石亭・三道俱進（黃武七年，228）
 * 史實：《陸遜傳》「七年，權使鄱陽太守周魴譎魏大司馬曹休。休果舉眾入皖，乃召遜假黃鉞，為大都督，逆休。休既覺知，恥見欺誘，
 *       自恃兵馬精多，遂交戰。遜自為中部，令朱桓、全琮為左右冀，三道俱近，果沖休伏兵，因驅走之，追亡逐北，逕至夾石，
 *       斬獲萬餘，牛馬騾驢車乘萬輛，軍資器械略盡。」（「冀」「近」照維基文庫原字，一般讀作「翼」「進」）
 *       《曹休傳》「休深入，戰不利，退還宿石亭。軍夜驚，士卒亂，棄甲兵輜重甚多。」
 *       《賈逵傳》「乃兼道進軍，多設旗鼓爲疑兵，贼見逵軍，遂退。」《朱桓傳》朱桓請斷夾石，「遜以為不可，故計不施行」。
 * 流程：1. 三道俱進：北道朱桓、南道全琮自己往前推（遇到魏兵會停下來打）；陸遜走中道。中道超前兩翼太多會被包圍（戰敗），
 *          中道草叢裡的伏兵在三道齊頭時一衝就散，不齊就要硬打。
 *       2. 石亭：曹休自恃兵多交戰，打到一半就敗走。
 *       3. 軍夜驚：天黑，魏兵亂竄、輜重散了一地，一路追到夾石（斬獲、車乘）。賈逵的疑兵出現在夾石就收兵。 */
// @ts-nocheck
import { SG } from '../../core/sg.ts';
import { setLevel, ally, allyTick, boss, hero, rout, vanish } from '../kit.ts';
import { MEN, WEI, WU, band, night, drawBanner } from './luxun_kit.ts';
import { START, SHITING, JIASHI, END, LANES, LANE_X0, LANE_X1, AMBUSH } from '../maps/luxun_shiting.ts';

const LV = 16, PACE = 75, AHEAD = 700, AHEAD_T = 6, EVEN = 420, JIA_T = 75;
const WEIB = { spec: WEI, name: '魏兵', hp: 520, maxHp: 520, atk: 28 };

export default {
  id: 'luxun-3', map: 'luxun_shiting', hero: 'luxun',
  title: '第 3 章　石亭・三道俱進', year: '黃武七年（228）',
  brief: {
    quote: [{ text: '遜自為中部，令朱桓、全琮為左右冀，三道俱近，果沖休伏兵。', src: '《三國志·吳書·陸遜傳》' }],
    text: '鄱陽太守周魴詐降，剪了頭髮向郡府謝罪，曹休信以為真，率步騎十萬入皖。孫權親自執鞭，假陸遜黃鉞，為大都督迎擊。曹休發覺受騙，仍自恃兵多，決意一戰。',
    goals: ['三道俱進：中道不要超前兩翼太多', '石亭：擊走曹休', '追亡逐北，逕至夾石'],
  },
  words: { ally: '吳兵', foe: '魏兵' },
  stars: [
    { text: '三處伏兵都是三道齊進、一衝就散', ok: (m) => m.vars.crushed === 3 },
    { text: '斬獲 20 以上', ok: (m) => m.vars.kills >= 20 },
    { text: '收得輜重 8 車以上', ok: (m) => m.vars.cars >= 8 },
  ],
  steps: [
    { // 0. 三道俱進
      enter(m, w) {
        const me = w.player, V = m.vars;
        setLevel(w, me, LV);
        me.x = START[0] + 300; me.y = START[1];
        V.crushed = 0; V.kills = 0; V.cars = 0; V.aheadT = 0;
        V.men = band(m, me, 8, '中軍', WU, { hp: 600, maxHp: 600, atk: 26 });
        V.wings = [[MEN.zhuhuan, '朱桓', LANES[0]], [MEN.quancong, '全琮', LANES[2]]].map(([spec, name, y]) => {
          const g = ally(w, spec, LANE_X0 - 200, y, LV - 1); g.name = name; g.lane = y; g.hx = LANE_X0 - 200; g.hold = [g.hx, y];
          g.men = band(m, g, 6, '吳兵', WU, { hp: 600, maxHp: 600, atk: 26 });
          return g;
        });
        // 兩翼路上的魏兵（翼軍要停下來打）
        V.lane = [];
        for (const y of [LANES[0], LANES[2]]) for (const x of [3500, 5300]) for (let i = 0; i < 4; i++) { const u = m.foe('huangjin', x + (i % 2) * 80, y - 60 + Math.floor(i / 2) * 120, WEIB); u.home = [u.x, u.y]; V.lane.push(u); }
        // 中道草叢裡的伏兵
        V.amb = AMBUSH.map(([x, y]) => ({ x, y, hit: false, us: Array.from({ length: 6 }, (_, i) => { const u = m.foe('huangjin', x - 120 + (i % 3) * 120, y - 40 + Math.floor(i / 3) * 80, Object.assign({}, WEIB, { name: '伏兵' })); u.asleep = true; return u; }) }));
        m.card('權使鄱陽太守周魴譎魏大司馬曹休。休果舉眾入皖，乃召遜假黃鉞，為大都督，逆休。', '《陸遜傳》（大都督篇）');
        m.after(6, () => m.card('魴乃詣部郡門下，因下發謝，故休聞之，不復疑慮。（陸機〈為遜銘〉：「乃假公黃鉞……主上執鞭，百司屈膝。」）', '《周魴傳》、裴注引陸機〈為遜銘〉'));
        m.after(12, () => m.line('陸遜', '吾自為中部。朱桓、全琮為左右翼，三道並進，不得前後參差。'));
        m.after(16, () => m.line('提示', '左右翼會自己往前推，遇到魏兵會停下來打。中道不要跑在兩翼前面太多；三道齊頭時撞上伏兵，伏兵一衝就散。'));
        m.obj('even', '');
        m.mark('st', SHITING[0], SHITING[1], '石亭');
      },
      tick(m, w, dt) {
        const me = w.player, V = m.vars;
        // 兩翼：沒在打仗就往前推，最多比中道超前 400；到了道路盡頭就往石亭會合
        for (const g of V.wings) {
          if (!g.alive) continue;
          const busy = w.units.some((u) => u.alive && u.team === 1 && !u.asleep && !u.untargetable && SG.gd(u.x, u.y, g.hold[0], g.hold[1]) < 480);
          if (!busy && g.hx < me.x + 400) g.hx = Math.min(LANE_X1 + 300, g.hx + PACE * dt);
          g.hold = g.hx >= LANE_X1 + 300 ? [SHITING[0] - 500, SHITING[1] + (g.lane < SHITING[1] ? -250 : 250)] : [g.hx, g.lane];
        }
        const wx = V.wings.filter((g) => g.alive).map((g) => g.hx), lag = me.x - Math.min(...wx); // 中道比落後的那一翼超前多少
        V.lag = lag;
        if (lag > AHEAD) { V.aheadT += dt; if (!V.warned) { V.warned = true; m.big('中軍孤進！'); m.line('朱桓', '大都督！左右翼還沒跟上！'); } }
        else { V.aheadT = Math.max(0, V.aheadT - dt * 2); V.warned = false; }
        if (V.aheadT > AHEAD_T) { m.lose('中軍孤軍深入，被曹休重兵包圍'); return false; }
        m.get('even').text = lag > AHEAD ? `中軍超前兩翼 ${Math.round(lag)}：退回去！` : Math.abs(lag) <= EVEN ? '三道並進：齊' : lag > 0 ? '三道並進：中軍稍前' : '三道並進：兩翼在前';
        // 伏兵：中道走近就跳出來；三道齊頭就一衝而散
        for (const A of V.amb) {
          if (A.hit || SG.gd(me.x, me.y, A.x, A.y) > 450) continue;
          A.hit = true;
          for (const u of A.us) u.asleep = false;
          if (Math.abs(lag) <= EVEN) { V.crushed++; m.big('果衝休伏兵！'); rout(m, w, A.us, [END[0], A.y]); m.line('陸遜', '伏兵已破，驅走之！'); }
          else { m.line('魏將', '吳軍只有一路，殺！'); for (const u of A.us) { u.home = [me.x, me.y]; u.hp = u.maxHp = 700; } }
        }
        return me.x > SHITING[0] - 900 && V.wings.every((g) => !g.alive || g.hx >= LANE_X1 - 200);
      },
    },
    { // 1. 石亭交戰
      enter(m, w) {
        const me = w.player, V = m.vars;
        m.drop('even');
        m.card('休既覺知，恥見欺誘，自恃兵馬精多，遂交戰。', '《陸遜傳》');
        V.cx = boss(w, hero('caoxiu'), SHITING[0] + 200, SHITING[1], { name: '曹休', hp: 7000, atk: 70, armor: 10, ms: 240 });
        V.wei = [];
        for (let i = 0; i < 12; i++) { const u = m.foe('huangjin', SHITING[0] - 100 + (i % 4) * 90, SHITING[1] - 260 + Math.floor(i / 4) * 260, WEIB); u.home = [me.x, me.y]; V.wei.push(u); }
        for (const g of V.wings) g.hold = null;
        m.mark('cx', V.cx.x, V.cx.y, '曹休', false, V.cx);
        m.obj('cx', '擊走曹休');
        m.after(3, () => m.line('曹休', '周魴小兒竟敢欺我！我兵馬十萬，還怕你一個書生？'));
      },
      tick(m, w) { return m.vars.cx.hp < m.vars.cx.maxHp * 0.5; },
    },
    { // 2. 軍夜驚，追亡逐北
      enter(m, w) {
        const me = w.player, V = m.vars;
        m.done('cx'); m.unmark('cx');
        V.cx.untargetable = true; V.cx.rout = true; V.cx.home = END.slice(); V.cx.ms = 280; V.cx.caster = false;
        m.after(8, () => vanish(w, V.cx));
        m.big('因驅走之！');
        m.after(3, () => { V.night = true; m.card('休深入，戰不利，退還宿石亭。軍夜驚，士卒亂，棄甲兵輜重甚多。', '《曹休傳》'); });
        // 夜驚：魏兵四散亂竄，不回手
        V.panic = [];
        const left = m.alive(V.wei);
        for (const u of left) { u.panic = true; V.panic.push(u); }
        for (let i = 0; i < 22; i++) { const u = m.foe('huangjin', SHITING[0] + 300 + (i % 6) * 260 + SG.rand() * 80, SHITING[1] - 500 + Math.floor(i / 6) * 300 + SG.rand() * 80, Object.assign({}, WEIB, { name: '潰兵', hp: 300, maxHp: 300, ms: 170 })); u.panic = true; V.panic.push(u); }
        // 棄甲兵輜重：散在往夾石的路上
        V.carList = [];
        for (let i = 0; i < 12; i++) V.carList.push(m.loot(SHITING[0] + 300 + i * 150 + (i % 2) * 60, SHITING[1] + (i % 3 - 1) * 260, 'gold', { n: 30, name: '輜重車', car: true }));
        V.t2 = w.t; V.chase = true;
        for (const g of V.wings) g.hold = null;
        m.mark('js', JIASHI[0], JIASHI[1], '夾石');
        m.obj('chase', '追亡逐北，逕至夾石');
      },
      tick(m, w) {
        const me = w.player, V = m.vars;
        V.cars = V.carList.filter((l) => l.got).length;
        const t = w.t - V.t2;
        m.get('chase').text = `追亡逐北，逕至夾石（斬獲 ${V.kills}、車乘 ${V.cars}）`;
        return t > JIA_T || me.x > JIASHI[0] - 300;
      },
    },
    { // 3. 賈逵疑兵：收兵
      enter(m, w) {
        const V = m.vars;
        V.chase = false;
        m.done('chase'); m.unmark('js');
        V.jk = boss(w, MEN.jiakui, JIASHI[0] + 250, JIASHI[1], { name: '賈逵', untargetable: true, hp: 9999, caster: false });
        V.jk.home = [V.jk.x, V.jk.y];
        V.flags = [[-160, -380], [120, -330], [-60, 330], [200, 380], [360, 0]].map(([dx, dy]) => m.folk(JIASHI[0] + 250 + dx, JIASHI[1] + dy, { still: true, near: 1, name: '', up: true, col: '#3b5a99', text: '賈', draw: drawBanner }));
        rout(m, w, V.panic, END);
        m.big('夾石上旌旗滿山');
        m.card('逵乃兼道進軍，多設旗鼓爲疑兵，贼見逵軍，遂退。逵据夹石，以兵粮给休，休軍乃振。', '《賈逵傳》');
        m.after(7, () => m.line('朱桓', '請以萬兵柴斷夾石、掛車，可生擒曹休，乘勝長驅，近取壽春！'));
        m.after(11, () => m.line('陸遜', '不可。夾石已有魏軍，追亦無益。斬獲已多，振旅而還。'));
        m.after(15, () => m.card('權先與陸遜議，遜以為不可，故計不施行。', '《朱桓傳》'));
        m.after(21, () => m.card('斬獲萬餘，牛馬騾驢車乘萬輛，軍資器械略盡。休還，疽發背死。諸軍振旅過武昌，權令左右以御蓋覆遜，入出殿門。', '《陸遜傳》'));
        m.after(28, () => m.win());
      },
      tick() { return false; },
    },
  ],
  always(m, w) {
    const me = w.player, V = m.vars;
    if (!me.alive) { m.lose('陸遜陣亡'); return; }
    if (V.wings) for (const g of V.wings) allyTick(w, g, g.hold ? null : me, 480);
    // 伏兵沒跳出來之前：藏在草裡不動
    if (V.amb) for (const A of V.amb) for (const u of A.us) if (u.alive && u.asleep) { if (u.hp < u.maxHp) { u.asleep = false; continue; } u.target = null; u.think = 0.5; u.home = [u.x, u.y]; }
    // 潰兵：不回手，往東亂竄；被殺的算斬獲
    if (V.panic) for (const u of V.panic) {
      if (!u.alive) { if (!u.tallied && V.chase && !u.rout) { u.tallied = true; V.kills++; } continue; }
      if (u.rout) continue;
      u.target = null; u.think = 0.5;
      if (!u.goal || SG.gd(u.x, u.y, u.goal[0], u.goal[1]) < 40) u.goal = [Math.min(JIASHI[0] - 100, u.x + 150 + SG.rand() * 250), SHITING[1] + (SG.rand() - 0.5) * 900];
      u.home = u.goal;
    }
  },
  overlay(ctx, m, view, x0, y0, vw, vh) { if (m.vars.night) night(ctx, x0, y0, vw, vh, 0.42); },
};
